const STORAGE_KEY = "feedFilters";

function loadFromStorage() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch (e) {
    // ignore
  }
  return null;
}

function saveToStorage(data) {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (e) {
    // ignore
  }
}

const state = () => {
  const stored = loadFromStorage();
  return stored || {
    selections: {},
    selectionLabels: {},
    effectiveSelections: {},
    queryParams: "",
  };
};

const mutations = {
  setSelections(state, { selections, selectionLabels, effectiveSelections, queryParams }) {
    state.selections = selections || {};
    state.selectionLabels = selectionLabels || {};
    state.effectiveSelections = effectiveSelections || {};
    state.queryParams = queryParams || "";
    saveToStorage({
      selections: state.selections,
      selectionLabels: state.selectionLabels,
      effectiveSelections: state.effectiveSelections,
      queryParams: state.queryParams,
    });
  },
  clearSelections(state) {
    state.selections = {};
    state.selectionLabels = {};
    state.effectiveSelections = {};
    state.queryParams = "";
    if (typeof window !== "undefined") {
      localStorage.removeItem(STORAGE_KEY);
    }
  },
};

const getters = {
  hasActiveFilters(state) {
    return Object.values(state.selections).some((arr) => arr && arr.length > 0);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
